// extracted by css-extract-rspack-plugin
export default {"resumesVisibilitySettingsModalContent":"resumes-visibility-settings-modal-content--ohkuToGUQLcsRnYy"};